import { render, staticRenderFns } from "./UserLoginNotification.vue?vue&type=template&id=16e4a38a&"
import script from "./UserLoginNotification.vue?vue&type=script&lang=ts&"
export * from "./UserLoginNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports